module.exports = __webpack_public_path__ + "static/img/H7-b2.adab85b3.jpg";